// Mock data for A Plus Flavor Restaurant

import logo from "../assets/logos/ICON.png";
import heroImage from "../assets/images/hero-image.png";

import categoryGriotImage from "../assets/images/combo.jpg";
import categoryRiceBeansImage from "../assets/images/legumediriblan.png";
import categorySaucesImage from "../assets/images/sides.jpg";
import categorySeafoodImage from "../assets/images/fish-plate.jpg";
import categorySoupsImage from "../assets/images/Bolyon.jpg";
import categoryJuicesImage from "../assets/images/drinks.jpg";
import categoryBarImage from "../assets/images/drinks.jpg";
import categoryPastriesImage from "../assets/images/desserts.jpg";
import categoryPlantainsImage from "../assets/images/sides.jpg";

export const restaurantInfo = {
  name: "A Plus Flavor",
  tagline: "Restaurant & Bar",
  location: "Newark, NJ",
  slogan: "AUTHENTIC HAITIAN FOOD",
  phone: "(973) 350-6522",
  email: "info@aplusflavor.com",
  address: "677 Bergen St., Newark, NJ 07108",
  logo,
  heroImage,
  hours: {
    monday: "Closed",
    tuesday: "10:00am - 8:00pm",
    wednesday: "10:00am - 8:00pm",
    thursday: "10:00am - 8:00pm",
    friday: "10:00am - 8:00pm",
    saturday: "10:00am - 8:00pm",
    sunday: "10:00am - 8:00pm",
  },
  social: {
    facebook: "https://facebook.com/aplusflavorrestaurant",
    instagram: "https://www.instagram.com/aplusflavorrestaurant",
  },
};

export const menuCategories = [
  {
    id: 1,
    name: "Griot",
    description:
      "Griot is our specialty - marinated fried pork that is golden crispy on the outside and tender on the inside, prepared using authentic Haitian spices.",
    image: categoryGriotImage,
  },
  {
    id: 2,
    name: "Rice & Beans",
    description:
      "In addition to our meats, we also have traditional rice dishes that you will love. We partner our delicious rice with tasty beans and sauces including Diri ak Pwa and Diri Djon Djon.",
    image: categoryRiceBeansImage,
  },
  {
    id: 3,
    name: "Pikliz & Sauces",
    description:
      "How do we make our dishes more flavorful? Through savory sauces, of course! We offer a selection of homemade pikliz and sauces made using the freshest ingredients.",
    image: categorySaucesImage,
  },
  {
    id: 4,
    name: "Seafood",
    description:
      "If you want fresh and delicious seafood, we recommend choosing from our seafood menu. Our dishes include Pwason and other fish prepared Haitian style.",
    image: categorySeafoodImage,
  },
  {
    id: 5,
    name: "Soups & Stews",
    description:
      "Do you like hearty soups? In that case, our selection of traditional soups is perfect for you. We offer Soup Joumou, Bouyon, and traditional comfort stews.",
    image: categorySoupsImage,
  },
  {
    id: 6,
    name: "Fresh Juices",
    description:
      "A Plus Flavor is where you can find refreshing beverages you won't find anywhere else. We have tropical juices, Kremas, and traditional Haitian drinks!",
    image: categoryJuicesImage,
  },
  {
    id: 7,
    name: "Bar & Spirits",
    description:
      "Besides refreshing beverages, we also have premium rum selections. Enjoy Haitian Barbancourt, craft cocktails, and imported Caribbean beers.",
    image: categoryBarImage,
  },
  {
    id: 8,
    name: "Haitian Pastries",
    description:
      "Combine the deliciousness of fresh-baked goods with authentic Haitian flavors. Our pate kode and traditional pastries are made daily.",
    image: categoryPastriesImage,
  },
  {
    id: 9,
    name: "Plantains",
    description:
      "We also carry our signature plantain dishes. Bannann Peze, sweet plantains, and more - all prepared fresh with NO shortcuts and NO artificial ingredients.",
    image: categoryPlantainsImage,
  },
];

export const detailedMenu = {
  combos: [
    {
      id: 1,
      name: "Chicken",
      price: 17.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 2,
      name: "Turkey",
      price: 21.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 3,
      name: "Goat",
      price: 29.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 4,
      name: "Griot",
      specialNote: "Fried Pork",
      price: 19.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 5,
      name: "Oxtail",
      specialNote: "Thursday ONLY",
      price: 34.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 6,
      name: "Fish",
      price: 24.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 7,
      name: "Legume",
      specialNote: "Vegetable Stew - Wednesday & Saturday",
      price: 19.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
    {
      id: 8,
      name: "Kalalou",
      specialNote: "Okra Stew - Tuesday ONLY",
      price: 17.99,
      note: "Includes a side of rice, mac and cheese, and three fried plantains",
    },
  ],
  sides: [
    {
      id: 1,
      name: "Brown Rice",
      price: 8.99,
    },
    {
      id: 2,
      name: "Black Rice",
      price: 9.49,
    },
    {
      id: 3,
      name: "White Rice",
      price: 6.99,
    },
    {
      id: 4,
      name: "Rice and Peas",
      price: 8.99,
    },
    {
      id: 5,
      name: "Vegetable Seafood Rice",
      price: 10.89,
    },
    {
      id: 6,
      name: "Bouillon",
      specialNote: "Haitian Soup - Friday",
      price: 16.99,
    },
    {
      id: 7,
      name: "Turkey",
      price: 9.99,
    },
    {
      id: 8,
      name: "Griot",
      price: 8.99,
    },
    {
      id: 9,
      name: "Goat",
      price: 14.99,
    },
    {
      id: 10,
      name: "Fish",
      price: 17.99,
    },
    {
      id: 11,
      name: "Chicken",
      price: 6.99,
    },
    {
      id: 12,
      name: "Legumes",
      specialNote: "Wednesday & Saturday",
      price: 11.99,
    },
    {
      id: 13,
      name: "Oxtail",
      specialNote: "Thursday ONLY",
      price: 19.99,
    },
    {
      id: 14,
      name: "Plantains",
      price: 9.99,
      quantity: "6",
    },
  ],
  drinks: [
    {
      id: 1,
      name: "Water",
      price: 0.99,
    },
    {
      id: 2,
      name: "Cola Couronne",
      price: 2.99,
    },
    {
      id: 3,
      name: "Malta",
      price: 1.99,
    },
  ],
};

export const navLinks = [
  { name: "HOME", href: "#home" },
  { name: "ABOUT", href: "#about" },
  { name: "MENU", href: "#menu" },
  { name: "REVIEWS", href: "#reviews" },
  { name: "CONTACT", href: "#contact" },
];
